import { KeyboardEvent } from "react";
import { SearchInputForm } from "src/components/common/form/search/SearchInputForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { defaultEQM2010_R01Filter, useEQM2010_R01Store } from "./Store_EQM2010_R01";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
// 팝업 연동 추가
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import useUiuxStore from "src/store/useUiuxStore";

import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";

// Props 타입 정의: 사업장명, 변경 핸들러, 엔터키 핸들러
interface Props {
  onEnterKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
}

// 사업장 검색 영역 컴포넌트
export const SearchSection_EQM2010_R01 = ({ onEnterKeyDown }: Props) => {

	const { compCdList, workPlaceList, eqmTypeList } = useCommonCodeStore();
	const { EQM2010_R01Filter, setEQM2010_R01Filter } = useEQM2010_R01Store();

	// 팝업 제어 & 검색 훅
	const { setCodeSearchModalProps } = useUiuxStore();

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'equipmentCd',
			category: '설비코드',
			focusId: 'equipmentCd_search',
			responseMapping: {
				equipmentCd: 'equipmentCd',
				equipmentNm: 'equipmentNm',
			},
			extraFilter: () => ({
				equipmentCd: EQM2010_R01Filter.equipmentCd || ''
			})
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: EQM2010_R01Filter,
		setEditData: setEQM2010_R01Filter,
		defaultData: defaultEQM2010_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'EQM2010_R01_search'
	});

	return (
		<SearchSectionForm>
			<SearchDropDownForm
				label="사업장"
				value={EQM2010_R01Filter.compCd}
				onChangeItem={(item) => setEQM2010_R01Filter({ compCd: item?.compCd || ''})}
				optionList={compCdList}
			/>
			<SearchDropDownForm
				label="공정유형"
				value={EQM2010_R01Filter.workplaceCd}
				onChangeItem={(item) => setEQM2010_R01Filter({ workplaceCd: item?.workplaceCd || ''})}
				optionList={workPlaceList}
			/>
			<SearchDropDownForm
				label="설비유형"
				value={EQM2010_R01Filter.equipmentType}
				onChangeItem={(item) => setEQM2010_R01Filter({ equipmentType: item?.minorCd || ''})}
				optionList={eqmTypeList}
			/>
			<SearchCodeModalForm
				label="설비코드"
				value={EQM2010_R01Filter.equipmentCd}
				valueLabel={EQM2010_R01Filter.equipmentNm || ''}
				handleFoucsId="equipmentCd_search"
				onChange={getFieldHandlers('equipmentCd').onChange}
				onDoubleClick={getFieldHandlers('equipmentCd').onDoubleClick}
				onKeyDown={getFieldHandlers('equipmentCd').onEnterKeyDown}
			/>
		</SearchSectionForm>
	)

}